module.exports = __webpack_public_path__ + "media/images/logo_standard-336e837d.png";